import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';

import { FuseSharedModule } from '@fuse/shared.module';

import { ApprovalsEquipmentsApi } from '@api/approvals-equipments/approvals-equipments.api';
import { ApprovalsEquipmentsService } from 'app/main/approvals-equipments/services/approvals-equipments.service';
import { TabApprovalsEquipmentsComponent } from './tab-approvals-equipments.component';

@NgModule({
    declarations: [
        TabApprovalsEquipmentsComponent
    ],
    imports     : [
        TranslateModule,
        MatIconModule,
        MatTooltipModule,
        FuseSharedModule,

        MatInputModule
    ],
    exports: [
        TabApprovalsEquipmentsComponent
    ],
    providers: [
        ApprovalsEquipmentsService,
        ApprovalsEquipmentsApi
    ]
})
export class TabApprovalsEquipmentsModule { }
